import { BrowserCacheLocation, Configuration, PublicClientApplication } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "dd4799ce-5515-488a-8115-238ff234b89e",
    authority: "https://login.microsoftonline.com/045c0c45-3c80-4b73-b52f-42f07d6207d4",
    knownAuthorities: ["https://login.microsoftonline.com"],
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

export const msalApp = new PublicClientApplication(msalConfig);
